import React from "react";
import PropTypes from "prop-types";

import RevSharedWrapper from "./styles/RevShare.style";

function RevShare(props) {
  const { auth, additionalInfo } = props;
  const { loggedIn, user } = auth;

  let jukinSplit = 0;
  const riffUser = loggedIn && user.roles.includes("ROLE_RIFF_USER");
  if (Boolean(additionalInfo)) {
    jukinSplit = 100 - additionalInfo.licensingRevSplit;
  }

  return (
    <RevSharedWrapper>
      {Boolean(additionalInfo) && riffUser && (
        <div>
          {additionalInfo.agreementType === "REV_SPLIT" && (
            <div className="rev__wrapper">
              <div>
                {additionalInfo.licensingRevSplit}/{jukinSplit} RevShare
              </div>
            </div>
          )}

          {additionalInfo.agreementType === "BUY_OUT" &&
            additionalInfo.isRecouped === false && (
              <div className="rev__wrapper">
                <div>Buyout ${additionalInfo.paid}</div>
              </div>
            )}

          {additionalInfo.agreementType === "BUY_OUT" &&
            additionalInfo.isRecouped === true && (
              <div className="rev__wrapper">
                <div>Buyout ${additionalInfo.paid}</div>
              </div>
            )}

          {additionalInfo.isRecouped === false &&
            additionalInfo.agreementType !== "BUY_OUT" && (
              <div className="rev__wrapper">
                <div>Advance ${additionalInfo.paid}</div>
              </div>
            )}
        </div>
      )}
    </RevSharedWrapper>
  );
}

RevShare.propTypes = {
  auth: PropTypes.object.isRequired,
  additionalInfo: PropTypes.object,
};

RevShare.defaultProps = {
  additionalInfo: null,
};

export default RevShare;
